import React, { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import {
  Link as MuiLink,
  Button,
  ListItem,
  makeStyles,
} from "@material-ui/core";
import { Icon } from "react-feather";

const useStyles = makeStyles((theme) => ({
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  title: {
    marginRight: "auto",
  },
  buttonLeaf: {
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    fontWeight: theme.typography.fontWeightRegular,
  },
  buttonBold: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  active: {
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
}));

interface AppNavLinkProps {
  root: boolean;
  href: string;
  title: string;
  icon?: Icon;
}

const AppNavLink: FunctionComponent<
  AppNavLinkProps & React.HTMLAttributes<HTMLDivElement>
> = ({ title, href, root, className, icon: LinkIcon }) => {
  const classes = useStyles();

  let buttonLink = <div />;
  const buttonContent = (
    <>
      {LinkIcon && <LinkIcon className={classes.icon} size="20" />}
      <span className={classes.title}>{title}</span>
    </>
  );

  try {
    // If we can construct a URL that means it's an external link and we should use MuiLink
    // as our component.
    new URL(href);
    buttonLink = (
      <Button
        className={clsx(classes.buttonLeaf, { [classes.buttonBold]: root })}
        component={MuiLink}
        href={href}
        underline="none"
      >
        {buttonContent}
      </Button>
    );
  } catch {
    // Otherwise it's an itnernal link and we want to use a react-router link (NavLink) for the
    // navigation.
    buttonLink = (
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, { [classes.buttonBold]: root })}
        component={NavLink}
        exact
        to={href}
      >
        {buttonContent}
      </Button>
    );
  }

  return (
    <ListItem className={clsx(classes.itemLeaf, className)} disableGutters>
      {buttonLink}
    </ListItem>
  );
};

export default AppNavLink;
